// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"947":"50a76bf0","973":"3a235fe3"}[chunkId] + ".css";
};